"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeOffset = void 0;
/* https://confluence.shopee.io/pages/viewpage.action?pageId=912400229 */
var getTimeOffset = function (ntp_t1, ntp_t2, ntp_t3, ntp_t4) {
    if (typeof ntp_t2 !== 'number' || typeof ntp_t3 !== 'number') {
        return 0;
    }
    return Math.floor(((ntp_t2 - ntp_t1) + (ntp_t3 - ntp_t4)) / 2);
};
exports.getTimeOffset = getTimeOffset;
